module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'exhibition-single',
        params: {
          year: _vm.startYear,
          id: _vm.exhibition.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "preview-home"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.exhibition.mainImage,
      "alt": _vm.exhibition.title
    }
  }), _c('div', {
    staticClass: "captions"
  }, [_c('h2', {
    staticClass: "h-xl ex-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h4', {
    staticClass: "h-l"
  }, [_vm._v(_vm._s(_vm.displayDate))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15831b2e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomeExhibition.vue
// module id = 228
// module chunks = 1